// Global contact information and social media URLs
// Set any URL to an empty string to hide it from the website

// Contact email addresses
export const contactEmail = "hello@containerizedconversations.com";
export const businessEmail = "partnerships@containerizedconversations.com";

// Social media URLs
export const facebookUrl = "";  // Example: "https://facebook.com/containerizedconversations"
export const twitterUrl = "";   // Example: "https://twitter.com/containerpod"
export const instagramUrl = ""; // Example: "https://instagram.com/containerizedconversations"
export const linkedinUrl = "";  // Example: "https://linkedin.com/company/containerizedconversations"
export const youtubeUrl = "";   // Example: "https://youtube.com/@containerizedconversations"